const React = require('react');

module.exports = ({tooltipComponent, dataHandler, titleHandler, valueHandler, hasCustomData}) => ({className, children, ...rest}) => {
  const hasTooltip = !!tooltipComponent;
  const val = hasCustomData ? {...rest} : children;
  const displayedVal = dataHandler ? dataHandler(val) : val;

  const Wrapper = tooltipComponent && displayedVal ? tooltipComponent : 'span';

  const wrapperProps = {
    className,
    onClick: (e) => e.stopPropagation()
  };

  if (hasTooltip) wrapperProps['title'] = titleHandler ? titleHandler(val) : val;
  if (hasTooltip && valueHandler) wrapperProps['value'] = valueHandler(val);

  return (
    <Wrapper {...wrapperProps}>
      { displayedVal ? displayedVal : '-' }
    </Wrapper>
  )
};
